import React from "react";
import { Card, Col, Row, Statistic, Spin, Typography } from "antd";
import { DollarCircleOutlined, UsergroupAddOutlined } from "@ant-design/icons";
import { roundToThreeDecimals } from "../../utils/roundToThreeDecimals";

interface ClientStatsProps {
  data: Array<{
    clientType: string;
    totalClients: number;
    totalDebtUSD: number;
    totalCompanyDebtUSD: number;
    totalClientPrepaidAmountUSD: number;
    totalCompanyPrepaidAmountUSD: number;
    _id: string;
  }>;
  loading: boolean;
}

export default function ClientStats({ data, loading }: ClientStatsProps) {
  if (loading) {
    return <Spin size="large" />;
  }

  if (!data || data.length === 0) {
    return <div>No data available</div>;
  }

  return (
    <div style={{ padding: "20px" }}>
      <h2 style={{ textAlign: "center" }}>Статистика по Клиентам</h2>

      {data.map((item) => (
        <div key={item._id} style={{ marginBottom: "30px" }}>
          <Card
            title={item.clientType}
            bordered={false}
            style={{ borderRadius: "8px" }}
          >
            <Row gutter={16}>
              {/* Total Clients */}
              <Col span={12}>
                <Card>
                  <Statistic
                    title="Всего клиентов"
                    value={item.totalClients}
                    prefix={<UsergroupAddOutlined />}
                  />
                </Card>
              </Col>

              <Col span={12}>
                <Card>
                  <Statistic
                    title="Долг клиента (USD)"
                    value={roundToThreeDecimals(item.totalDebtUSD)}
                    prefix={<DollarCircleOutlined />}
                  />
                </Card>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Card>
                  <Statistic
                    title="Долг компании (USD)"
                    value={roundToThreeDecimals(item.totalCompanyDebtUSD)}
                    prefix={<DollarCircleOutlined />}
                  />
                </Card>
              </Col>

              <Col span={12}>
                <Card>
                  <Statistic
                    title="Предоплата клиентов (USD)"
                    value={roundToThreeDecimals(
                      item.totalClientPrepaidAmountUSD
                    )}
                    prefix={<DollarCircleOutlined />}
                  />
                </Card>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Card>
                  <Statistic
                    title="Предоплата компании (USD)"
                    value={roundToThreeDecimals(
                      item.totalCompanyPrepaidAmountUSD
                    )}
                    prefix={<DollarCircleOutlined />}
                  />
                </Card>
              </Col>
            </Row>
          </Card>
        </div>
      ))}
    </div>
  );
}
